import type { components } from "@/shared/api";

type LocalizedName = components["schemas"]["LocalizedName"];

// Название героя или предмета — пока всегда английское, на любом языке интерфейса:
// официальный русский перевод звучит непривычно для игроков. Справочник хранит оба языка;
// вернуть язык интерфейса — `localizedName(name, locale)` вместо этой функции.
export const assetName = (name: LocalizedName): string => name.en;
